/**
 * "Alerts & Reports" workspace tab strip.
 *
 * Tabs:
 *   Alerts    → /alerts                (live rules-engine output)
 *   Reports   → /alerts/reports        (placeholder — auto-report bundles
 *               from Cluster 4 plan: lender pack PDF, equity flash,
 *               auditor evidence, board MI)
 */

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs, Tab, Box } from '@mui/material';

const TABS = [
  { value: 'alerts',  label: 'Alerts',  path: '/alerts' },
  { value: 'reports', label: 'Reports', path: '/alerts/reports' },
];

function resolveActiveTab(pathname) {
  if (pathname.includes('/reports')) return 'reports';
  return 'alerts';
}

export default function AlertsWorkspaceTabs() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const active = resolveActiveTab(pathname);

  return (
    <Box sx={{ borderBottom: '1px solid', borderColor: 'divider', mb: 2 }}>
      <Tabs
        value={active}
        onChange={(_, v) => {
          const t = TABS.find((x) => x.value === v);
          if (t) navigate(t.path);
        }}
        TabIndicatorProps={{ sx: { height: 2 } }}
        sx={{ minHeight: 38, '& .MuiTab-root': { minHeight: 38, py: 1 } }}
      >
        {TABS.map((t) => (
          <Tab key={t.value} value={t.value} label={t.label} />
        ))}
      </Tabs>
    </Box>
  );
}
